import { createContext, useEffect, useState } from "react";
import { message } from "antd";
import Loading from "../components/Loading";
import { useTranslation } from 'react-i18next';
import "./AppContext.sass";

export const AppContext = createContext({});

export const AppProvider = ({children}) => {
    const { i18n } = useTranslation();
    const [showAlert, setShowAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const showAlertAction = (type = 'success', messageText, title = '') => {
        switch(type) {
            case 'success':
                message.success(messageText);
                break;
            case 'error':
                message.error(messageText);
                break;
            case 'warning':
                message.warning(messageText);
                break;
            default:
                message.info(messageText);
        }
        setShowAlert(false);
    }

    const showConfirmAction = (callback, messageText, title = '') => {
        message.loading({ content: 'Đang xử lý...', key: 'confirm' })
            .then(() => {
                callback();
                message.success({ content: messageText || 'Thao tác thành công', key: 'confirm' });
                setShowAlert(false);
            });
    }

    return (
        <AppContext.Provider value={{ 
                showAlertAction, 
                showConfirmAction, 
                isLoading, 
                i18n,
                setIsLoading,
            }}
        >
            {children}
            {isLoading && <Loading loading={isLoading}/>}
        </AppContext.Provider>
    )
}